import styled from 'styled-components';

export const DatePickerInputWrapper = styled.div`
  width: 100%;

  div > div > button > span.react-datepicker__navigation-icon::before {
    border-color: #ccc;
    border-style: solid;
    border-width: 3px 3px 0 0;
    content: '';
    display: block;
    height: 10px;
    position: absolute;
    top: 6px;
    width: 10px;
  }

  .react-datepicker__navigation-icon--next::before {
    transform: rotate(45deg);
    left: -5px;
  }

  .react-datepicker__navigation-icon--previous::before {
    transform: rotate(225deg);
    right: -5px;
  }
`;

export default DatePickerInputWrapper;
